module.exports = __webpack_public_path__ + "media/img/vca/bg-about-c5f448ab6a81f356bfc431a24229c0e7.png";